module.exports = __webpack_public_path__ + "static/media/bg_minecraft-two.76c45e5b.png";